import jwt from '../../utils/jwt';
import * as api from './api';
import * as types from './mutations';

const state = {
    authenticated: false,
    me: undefined,
    token: jwt.getToken(),
};

const getters = {
    userDetail(state) {
        return function(type) {
            if (! state.me || !state.me[type]) return false;

            return state.me[type].data;
        }
    },
    hasRoles(state) {
        return function(roles) {
            if (! state.me) return false;

            return state.me.roles.data.some(role => roles.indexOf(role.name) > -1);
        }
    }
};

const mutations = {
    [types.SET_AUTH_USER](state, user) {
        state.authenticated = true;
        state.me = user;
    },

    [types.UNSET_AUTH_USER](state) {
        state.authenticated = false;
        state.me = undefined
    },

    [types.SET_ACCESS_TOKEN](state, token) {
        state.token = token;
    },

    [types.UPDATE_PROFILE_STATUS](state, status) {
        state.me.profile.data.status = status;
    }
};

const actions = {
    getAuthUser({commit}) {
        return new Promise((resolve, reject) => {
            axios.get(api.getAuthUser)
                .then(({data}) => {
                    commit(types.SET_AUTH_USER, data.data);
                    resolve(data);
                })
                .catch(({response}) => reject(response))
        });
    },

    renewToken({dispatch}, failedRequest) {
        return new Promise((resolve, reject) => {
            axios.get(api.renewToken)
            // If token is renewed successfully then we retry the failed request.
                .then(_ => {
                    axios.request(failedRequest).then(retryResponse => {
                        resolve(retryResponse);
                    });
                })
                // If token renewal is failed again, which means either jwt token is invalid
                // or token is not refreshable then user have to login again.
                .catch(_ => dispatch('logout', '/'))
        })
    },

    login({commit}, {email, password}) {
        return new Promise((resolve, reject) => {
            axios.post(api.login, {email, password})
                .then(({data}) => {
                    // TODO: check user role if admin or member then redirect to appropriate dashboard
                    // Currently we only have member dashboard so no need to check.
                    commit(types.SET_ACCESS_TOKEN, data.token);
                    resolve(data);
                })
                .catch(({response}) => reject(response))
        });
    },

    logout({commit}, redirectPath = '/') {
        return new Promise(_ => {
            jwt.clearToken();
            commit(types.UNSET_AUTH_USER);
            if(redirectPath !== 'current') window.location.href = redirectPath;
        });
    },
    
    sendResetEmail({}, {email}) {
        return new Promise((resolve, reject) => {
            axios.post(api.sendResetEmail, {email})
                .then(({data}) => data.statusCode === 200 && resolve(data.message))
                .catch(({response}) => reject(response.data.message));
        });
    },

    resetPassword({}, {email, token, password, password_confirmation}) {
        return new Promise((resolve, reject) => {
            axios.post(api.resetPassword, {email, token, password, password_confirmation})
                .then(({data}) => resolve(data.message))
                .catch(({response}) => reject(response.data.message));
        })
    },

    updateAuthProfileStatus({commit, state}, {status}) {
        commit(types.UPDATE_PROFILE_STATUS, status);
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};